/**
 * Directive: scrollableSelectList
 */
angular.module('acme.common.directive.scrollableSelectList', [])
.directive('scrollableSelectList', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scrollableSelectList/scrollableSelectList.tpl.html',
      scope: {
        model: '=',
        selected: '=',
        label: '@',
        propName: '@',
        useAlpha: '@',
        multiSelect: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$document', '$timeout', function($scope, $document, $timeout) {

        $scope.scrollableSelectList = {

          isLoaded: false,
          isScrolling: false,
          alphaSelected: '',
          lastAlphaSelected: '',
          selected: {},
          letters: {},
          currentListIndex: -1,
          search: {},
          listItems: {},

          init: function() {
            this.letters = this.getLetters();
            $document.bind('keyup', this.onKeyUp);

            $scope.$on('$destroy', $scope.$watch('model', this.onModelUpdate));
            $scope.$on('$destroy', $scope.$watch('scrollableSelectList.search.name', this.onSearchNameUpdate));
            $scope.$on('$destroy', function() {
              $document.unbind('keyup', $scope.scrollableSelectList.onKeyUp);
            });
          },

          scrollTo: function(letter, enabled) {
            var parent = $('.scrollable-select-list-inner-alpha .scrollable-select-list'),
                el = parent.find('#' + ((letter === '#') ? 'number' : letter)),
                top = Math.abs(el.position().top + parent.scrollTop());

            if (!this.isScrolling && enabled) {
              this.isScrolling = true;
              this.alphaSelected = letter;
              parent.animate({
                scrollTop: top
              }, {
                duration: 200,
                complete: function () {
                  var self = $scope.scrollableSelectList,
                      found = el.find('+ .scrollable-select-list-row > a.scrollable-select-list-add');
                  //els = $('.scrollable-select-list.selectable .scrollable-select-list-add.clickable');
                  found.focus();
                  self.currentListIndex = found.index( '.scrollable-select-list.selectable .scrollable-select-list-add.clickable' );

                  self.isScrolling = false;
                }
              });
            }

          },

          getLetters: function() {
            var i, ii,
                r = {};

            for (i=65,ii=91;i<ii;i++) {
              if (!r[String.fromCharCode(i)]) {
                r[String.fromCharCode(i)] = {};
              }
              r[String.fromCharCode(i)].enabled = false;
            }

            r['#'] = { enabled: false };

            return r;
          },

          enableLetter: function(letter) {
            this.letters[letter].enabled = true;
          },

          sortAlpha: function(items) {
            var i, ii,
                L,
                groups = {},
                char,
                letter,
                lastChar;

            for (L in this.letters) {
              if (this.letters.hasOwnProperty(L)) {
                groups[L] = {
                  name: L,
                  items: []
                };
              }
            }

            items.sort(function(a, b) {
              var r = 0,
                  _a = a && a.name ? a.name.toLowerCase() : '',
                  _b = b && b.name ? b.name.toLowerCase() : '';

              if (/^[^A-Za-z]/.test(_a)) {
                r = 1;
              }else {
                if (_a > _b) {
                  r = 1;
                } else if (_a < _b) {
                  r = -1;
                }
              }

              return r;
            });

            for (i=0,ii=items.length;i<ii;i++) {

              char = items[i].name ? $.trim(items[i].name.toLowerCase()).charAt(0) : '';
              letter = char.toUpperCase();

              if (char.length && char !== lastChar) {

                letter = /^[^A-Za-z]/.test(letter) ? '#' : letter;

                items[i].anchor = letter;
                lastChar = char;
                this.enableLetter(letter);
              }

              if (!groups.hasOwnProperty(letter)) {
                letter = '#';
              }

              groups[letter].items.push(items[i]);

            }

            return groups;

          },

          toggleItemAndClose: function(item) {
            this.toggleItem(item);
            $scope.$emit('ScrollableSelectList::Done', { selected: this.selected });
          },

          toggleItemWithEnter: function(e, item) {
            switch (e.key) {
              case 'Enter':
                this.toggleItemAndClose(item);
                break;
            }
          },

          toggleItemWithSpace: function(e, item) {
            switch (e.key) {
              case ' ':
                e.preventDefault();
                e.stopPropagation();
                this.toggleItem(item);
                break;
            }
          },

          toggleItem: function(item, event) {
            if (event) {
              this.currentListIndex = $(event.currentTarget).index('.scrollable-select-list.selectable .scrollable-select-list-add.clickable');
            }
            if ($scope.multiSelect) {
              item.selected = !item.selected;
              this.selected[item.name] = (item.selected);

              if (this.selected[item.name]) {
                this.selectedCount++;
              } else {
                this.selectedCount--;
              }
            }else{
              this.clearSelected();
              item.selected = true;
              this.selected[item.name] = item;
              $scope.selected = item;
            }
          },

          clearSelected: function() {
            var i, ii,
                L;

            if ($scope.useAlpha) {
              for (L in this.model) {
                if (this.model.hasOwnProperty(L)) {
                  for (i = 0, ii = this.model[L].items.length; i < ii; i++) {
                    this.model[L].items[i].selected = false;
                    this.selected[this.model[L].items[i].name] = false;
                  }
                }
              }
            }else {
              for (i = 0, ii = $scope.model.length; i < ii; i++) {
                this.model[i].selected = false;
                this.selected[this.model[i].name] = false;
              }
            }
          },

          onModelUpdate: function (n, o) {
            var self = $scope.scrollableSelectList;

            if (n !== o) {
              self.model = ($scope.useAlpha) ? self.sortAlpha(n) : n;
              if (!self.isLoaded && n.length) {
                self.isLoaded = true;
              }

            }
          },

          onSearchNameUpdate: function(n, o) {
            var self = $scope.scrollableSelectList;

            if (n !== o) {
              if (n && n.length) {
                if (self.alphaSelected.length) {
                  self.lastAlphaSelected = self.alphaSelected;
                  self.alphaSelected = '';
                }
              }else{
                self.alphaSelected = self.lastAlphaSelected;
                $timeout(function() {
                  self.scrollTo(self.alphaSelected, self.letters[self.alphaSelected].enabled);
                }, 10);
              }
              if (self.searchListTimer) {
                $timeout.cancel(self.searchListTimer);
              }
              // next tick
              self.searchListTimer = $timeout(function() {
                self.currentListIndex = -1;
              }, 10);
            }

          },

          onKeyUp: function(e) {
            var self = $scope.scrollableSelectList,
                els = $('.scrollable-select-list.selectable .scrollable-select-list-add.clickable');

            switch (e.key) {
              case 'ArrowUp':
                e.preventDefault();

                self.currentListIndex--;

                if (self.currentListIndex >= els.length) {
                  self.currentListIndex = els.length - 2;
                  els.eq(self.currentListIndex).focus();
                }else if (self.currentListIndex > -1) {
                  els.eq(self.currentListIndex).focus();
                }else if (self.currentListIndex <= -1) {
                  $('.scrollable-select-list-query input[type="text"]').focus();
                }
                break;
              case 'ArrowDown':
                e.preventDefault();

                self.currentListIndex++;

                if (self.currentListIndex > -1 && self.currentListIndex < els.length) {
                }else if (self.currentListIndex < 0) {
                  self.currentListIndex = 0;
                }else if (self.currentListIndex >= els.length) {
                  self.currentListIndex = els.length - 1;
                }
                els.eq(self.currentListIndex).focus();
                break;
              case 'Tab':
                if (e.shiftKey) {
                  self.currentListIndex--;

                  if (self.currentListIndex >= els.length) {
                    self.currentListIndex = els.length - 2;
                  }
                }else{
                  self.currentListIndex++;

                  if (self.currentListIndex > -1 && self.currentListIndex < els.length) {
                  }else if (self.currentListIndex < 0) {
                    self.currentListIndex = 0;
                  }else if (self.currentListIndex >= els.length) {
                    self.currentListIndex = els.length - 1;
                  }
                }
            }

          }

        };

        $scope.scrollableSelectList.init();

      }]

    };

}]);